<app-audit-life-cycle  [auditLifeCycleList]="auditLifecycleInput" [boxType]="'phase'"></app-audit-life-cycle>
